"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportDialogContextProvider = exports.useExportDialogContext = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var ExportDialogContext = react_1.createContext({
    isOpen: false,
    dialogConfig: {},
    closeDialog: noop_1.default,
    openDialog: noop_1.default,
});
/**
 * @internal
 */
exports.useExportDialogContext = function () {
    return react_1.useContext(ExportDialogContext);
};
/**
 * @internal
 */
exports.ExportDialogContextProvider = function (_a) {
    var children = _a.children;
    var _b = tslib_1.__read(react_1.useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var _c = tslib_1.__read(react_1.useState({}), 2), dialogConfig = _c[0], setDialogConfig = _c[1];
    var openDialog = react_1.useCallback(function (config) {
        if (config === void 0) { config = {}; }
        setIsOpen(true);
        setDialogConfig(config);
    }, []);
    var closeDialog = react_1.useCallback(function () {
        setIsOpen(false);
    }, []);
    var contextValue = react_1.useMemo(function () { return ({ isOpen: isOpen, dialogConfig: dialogConfig, openDialog: openDialog, closeDialog: closeDialog }); }, [isOpen, dialogConfig, openDialog, closeDialog]);
    return react_1.default.createElement(ExportDialogContext.Provider, { value: contextValue }, children);
};
//# sourceMappingURL=ExportDialogContext.js.map